import React from "react";
import styles from "./radio.module.scss";
import IComponentProps from "../common/component-props";
import clsx from "clsx";
import { testUtils } from "../../../utils/test-utils";

export enum RadioView {
  Default = "default",
  Compact = "compact"
}

interface IRadioProps extends IComponentProps {
  label?: string;
  view?: RadioView;
  name: string;
  checked: boolean;
  onClick: () => void;
}

export default function Radio(props: IRadioProps) {
  return (
    <label 
      className={clsx(
        styles.root, 
        props.disabled && styles["root--disabled"],
        props.view === RadioView.Compact && styles["root--compact"])}
      style={props.style}
    >
      <span className={styles.radio}>
        <input
          data-testid={props.testId || testUtils.stringToTestId(props.name)}
          type="radio"
          name={props.name}
          checked={props.checked}
          disabled={props.disabled}
          onChange={() => props.onClick()}
        />
        <span className={styles.center}></span>
      </span>
      <span className={styles.label}>{props.label}</span>
    </label>
  );
}
